import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function Navbar() {
  const { user, isPremium, logout } = useAuth()
  const location = useLocation()

  const links = [
    { to: '/gallery', label: '拼豆图集' },
    { to: '/', label: '图纸生成' },
    ...(user ? [{ to: '/profile', label: '个人中心' }] : []),
    ...(user?.isAdmin ? [{ to: '/admin', label: '后台' }] : []),
  ]

  return (
    <nav className="sticky top-0 z-50 border-b border-blush/30 bg-cream-50/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3">
        <Link to="/" className="flex items-center gap-2 text-xl font-bold text-cocoa transition hover:scale-105">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-blush text-xl text-white shadow-soft">🌱</span>
          豆田造物
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`rounded-full px-4 py-2 text-sm font-medium transition ${
                location.pathname === l.to
                  ? 'bg-blush-light text-blush-dark shadow-sm'
                  : 'text-cocoa-light hover:bg-cream-100'
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              {isPremium && (
                <span className="badge hidden bg-peach text-cocoa sm:inline-flex">
                  🌾 田主会员
                </span>
              )}
              <span className="hidden max-w-[120px] truncate text-sm text-cocoa-light sm:inline">
                {user.username || user.email}
              </span>
              <button
                onClick={() => logout()}
                className="rounded-full border border-lavender/60 px-3 py-1.5 text-sm font-medium text-cocoa hover:bg-lavender/30"
              >
                登出
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="rounded-full px-3 py-1.5 text-sm font-medium text-cocoa hover:bg-cream-100"
              >
                登录
              </Link>
              <Link
                to="/register"
                className="rounded-full bg-blush px-3 py-1.5 text-sm font-semibold text-white shadow-soft transition hover:bg-blush-dark"
              >
                注册
              </Link>
            </>
          )}
        </div>
      </div>

      {/* 移动端底部导航 */}
      <div className="flex border-t border-blush/20 bg-cream-50/95 md:hidden">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className={`flex-1 py-2.5 text-center text-xs font-medium transition ${
              location.pathname === l.to ? 'text-blush-dark' : 'text-cocoa-light'
            }`}
          >
            {l.label}
          </Link>
        ))}
      </div>
    </nav>
  )
}
